<template>
  <div class="wrapper">
    <meheader />
    <div class="content-wrapper mb-4" style="background-color: #f7f8fa">
      <div class="invert-wrapper">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <b-row class="mt-2">
            <b-col cols="6">
              <b-card
                @click="selcked = 1"
                :class="{ active: selcked == 1 }"
                class="card-icon-bg background_color card-icon-bg-primary o-hidden mb-30 text-center"
              >
                <div class="content">
                  <p class="text-white font-weight-bold mb-0">待评估</p>
                  <p class="text-white text-24 line-height-1 mb-2">
                    {{ pendingCount }}
                  </p>
                </div>
              </b-card>
            </b-col>
            <b-col cols="6">
              <b-card
                @click="selcked = 2"
                :class="{ active: selcked == 2 }"
                class="card-icon-bg background_color card-icon-bg-primary o-hidden mb-30 text-center"
              >
                <div class="content">
                  <p class="text-white font-weight-bold mb-0">已评估</p>
                  <p class="text-white text-24 line-height-1 mb-2">
                    {{ completeCount }}
                  </p>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" v-for="(item, index) in list" :key="index">
              <b-card
                @click="details(item.projectId, item.id)"
                class="min-height mt-2 card-icon-bg card-icon-bg-primary o-hidden"
              >
                <div class="content wrapper">
                  <span class="font-weight-bold"
                    >项目名称：{{ item.projectName }}</span
                  >
                  <span>{{ item.creationTime }}</span>
                </div>
                <div class="content wrapper mt-2">
                  <span>项目编号：{{ item.projectNo }}</span>
                </div>
                <div class="content wrapper mt-2">
                  <span>企业名称：{{ item.companyName }}</span>
                  <span>{{ item.industry }}</span>
                </div>
                <div class="content wrapper mt-2">
                  <span>
                    {{ item.projectDescription }}
                  </span>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </van-list>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import meheader from "@/components/meheader";
export default {
  components: {
    meheader,
  },
  name: "enterprise",
  watch: {
    selcked(val) {
      if (val == 1) {
        (this.PageIndex = 1), (this.list = []);
        this.onLoad();
      } else {
        this.list = [];
        (this.PageIndex = 1), this.onLoad();
      }
    },
  },
  data() {
    return {
      visible: true,
      selcked: 1,
      list: [],
      loading: false,
      finished: false,
      PageIndex: 1,
      pendingCount: 0,
      completeCount: 0,
    };
  },
  methods: {
    onLoad() {
      this.PageIndex + 1;
      this.request({
        url: "/v1.0/ThePublic/getExpertScoreTotal",
        method: "GET",
        params: {
          PageSize: 5,
          PageIndex: this.PageIndex,
          Status: this.selcked == 1 ? 100 : 200,
        },
      }).then((res) => {
        if (res.success) {
          this.list = [...res.data.pagedData.items];
          this.pendingCount = res.data.pendingCount;
          this.completeCount = res.data.completeCount;
          this.loading = false;
          if (res.data.pagedData.totalCount == this.list.length) {
            this.finished = true;
          }
        }
      });
    },
    details(projectId, id) {
      this.$router.push({
        name: "ProjectDetails",
        params: {
          projectId,
          id,
        },
      });
    },
  },
};
</script>
/* 100 待评估  200 以评估*/
<style lang="scss" >
@import "@/assets/scss/mixin.scss";
.background_color {
  background: rgb(237, 161, 13);
}
.font-wrapper {
  width: 100px;
  display: flex;
  justify-content: space-between;
}
.wrapper {
  width: 100%;
}
.van-list {
  width: 100%;
}
.content-wrapper {
  width: 100%;
  margin-top: 100px;
  .invert-wrapper {
    width: 90%;
    margin: 0 auto;
    .active {
      background-color: rgb(19, 105, 192);
    }
    .wrapper {
      display: flex;
      font-size: 10px;
      justify-content: space-between;
      & > span {
        display: inline-block;
      }
    }
  }
}
</style>
